var _defs, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarSinFoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71 71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#556080;}.cls-2{fill:#b3bbbc;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 71,
    height: 71
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25,55.6,14.4,61.3l-1.6,1.2a34.8,34.8,0,0,0,22.7,8.3,35.2,35.2,0,0,0,22.6-8.2l-1.8-1.2L45,55.7a4.2,4.2,0,0,1-2.4-3.8V47.5l1.1-1.4A27.6,27.6,0,0,0,47.2,39a3.5,3.5,0,0,0,2.5-3.3V30.9a3.7,3.7,0,0,0-1.2-2.6V21.5s1.4-10.7-13-10.7-13,10.7-13,10.7v6.8a3.7,3.7,0,0,0-1.2,2.6v4.8A3.4,3.4,0,0,0,23,38.6a22.6,22.6,0,0,0,4.2,8.9v4.3A4.3,4.3,0,0,1,25,55.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.1.2A35.3,35.3,0,0,0,12.8,62.5l1.6-1.2L25,55.6a4.3,4.3,0,0,0,2.2-3.8V47.5A22.6,22.6,0,0,1,23,38.6a3.4,3.4,0,0,1-1.7-2.9V30.9a3.7,3.7,0,0,1,1.2-2.6V21.5s-1.4-10.7,13-10.7,13,10.7,13,10.7v6.8a3.7,3.7,0,0,1,1.2,2.6v4.8A3.5,3.5,0,0,1,47.2,39a27.6,27.6,0,0,1-3.5,7.1l-1.1,1.4v4.4A4.2,4.2,0,0,0,45,55.7l11.3,5.7,1.8,1.2A35.3,35.3,0,0,0,36.1.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarSinFoto);
export default __webpack_public_path__ + "static/media/avatar-sin-foto.27b71873.svg";
export { ForwardRef as ReactComponent };